import React from "react";
export var ArrayItemContext = React.createContext(undefined);
export var useArrayItemData = function () {
    var context = React.useContext(ArrayItemContext);
    return context === null || context === void 0 ? void 0 : context.arrayItemData;
};
